import React from "react";
import Page from "components/Page";
import { Props } from "./ContactCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const ContactCustomTypes = lazyWithRetry(() => import("./ContactCustomTypes"));

export default (props: Props) => (
  <Page>
    <ContactCustomTypes {...props} />
  </Page>
);
